import React from 'react';
import MCQPreview from '../MCQPreview';
import MatrixPreview from '../MatrixPreview';
import ParagraphPreview from '../ParagraphPreview';
import { RemedialBasePreviewProps } from './RemedialPreviewConstant';
import { QUESTION_TYPES } from '../../../../../constants/comman';

interface RemedialPreviewWrapperProps extends RemedialBasePreviewProps {
  type: number;
}

const RemedialPreviewWrapper = (props: RemedialPreviewWrapperProps) => {
  const { type, ...restProps } = props;

  switch (type) {
    case QUESTION_TYPES.BLANKS:
    case QUESTION_TYPES.DESCRIPTIVE:
    case QUESTION_TYPES.INTEGER:
    case QUESTION_TYPES.NUMERICAL:
    case QUESTION_TYPES.SMCQ:
    case QUESTION_TYPES.TRUE_FALSE:
    case QUESTION_TYPES.MMCQ:
      return <MCQPreview {...restProps} />;
    case QUESTION_TYPES.MATRIX:
      return <MatrixPreview {...restProps} />;
    case QUESTION_TYPES.PARAGRAPH:
      return <ParagraphPreview {...restProps} />;
    default:
      return null;
  }
};

export default RemedialPreviewWrapper;
